<template>
  <div>
    <h3 v-if="mw && mw.title" class="mb-4">{{ mw.title }}</h3>
    <template v-if="mw.content">
      <p v-for="(t, i) in mw.content" :key="i" class="mb-2">{{ t }}</p>
    </template>
    <a-form-model2
      ref="formContract"
      v-model="data"
      class="mt-4"
      :model="model"
      :modelForm="modelForm"
      :values="data"
      :errors="errors"
      :config="{ dense: true, hideDetails: 'true', readonly: this.id }"
      @validate="validate($event)"
    />
    <s-tree-block :value="wizard" v-if="getAccess('contract.wizard.debug')" />

    <portal to="v-wizard-action" v-if="loaded">
      <v-btn v-if="!readonly && wizardData.template_id" @click="onUndo" class="mr-2">Назад</v-btn>
      <v-btn v-if="isChanged" @click="submit">Сохранить</v-btn>
      <v-btn v-if="wizardData.template_id && !isChanged" @click="onNext">Далее</v-btn>
    </portal>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, genModel, getAccess } from "@/components/mixings";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, genModel, getAccess],
  props: {
    wizard: {
      type: Object,
      default: () => {},
    },
    mw: {
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDocument: false,
      m: this.$store.getters["config/get"].models.contracts,
      model1: [],
      isNew: 0,
      model: [],
      id: null,
      loaded: false,
      type: 1,
      wizardData: {},
    };
  },
  computed: {
    readonly() {
      return false;
      return !!this.wizard?.contract?.template_id;
    },
    api() {
      return this.m.api;
    },
    config() {
      const c = this.mw?.config || {};
      if (!c.fieldsReplace) c["fieldsReplace"] = {};
      c.fieldsReplace["contract_type"] = { name: "contract_type", default: 1, _type: "join" };
      c.fieldsReplace["side_2_client_id"] = {
        name: "side_2_client_id",
        type: "selectapi",
        dir: "",
        api: "mechti/clients/select",
        default: this.wizard.client.id,
        validator: ["req"],
        _type: "join",
      };
      c.fieldsReplace["object_id"] = {
        name: "object_id",
        type: "selectapi",
        dir: "",
        api: "mechti/objects/select",
        default: this.wizard.object.id,
        validator: ["req"],
        _type: "join",
      };
      return c;
      return {
        note: " Договор с клиентом",
        fields:
          "data.prepay,object_id,type_contract_number,contract_number,name,contract_type,contract_date,contract_end,side_1_vendor_id,side_2_client_id,comments,status,docs,filesRemove,filesAdd,template_id,template_data",
        fieldsRO: "contract_type,side_2_client_id,object_id",
        fieldsForm:
          "type_contract_number#4,contract_number#8,name,contract_type#8,data.prepay#4,object_id,contract_date#6,contract_end#6,side_1_vendor_id,side_2_client_id,comments,docs",
        fieldsReplace: {
          contract_type: { name: "contract_type", default: 1, _type: "join" },
          side_2_client_id: { name: "side_2_client_id", default: this.wizard.client.clientId, validator: ["req"], _type: "join" },
          object_id: { name: "object_id", default: this.wizard.object.objectId, validator: ["req"], _type: "join" },
        },
      };

      return this.mw?.contract?.config || {}; //.wizardContract;
    },
  },
  created() {
    if (this.$root.dirs.service) {
    }
    this.init();
  },
  watch: {},
  methods: {
    waitFor(conditionFn) {
      return new Promise((resolve) => {
        const check = () => {
          if (conditionFn()) return resolve();

          // ждать и снова проверять
          setTimeout(check, 30);
        };
        check();
      });
    },
    waitForEvent(eventName, payload) {
      return new Promise((resolve) => {
        this.$emit(eventName, payload, resolve);
      });
    },
    async init() {
      this.loaded = !true;
      await this.waitFor(() => this.$root.dirs.service.length > 0);
      //console.log("wwwwwwwwww", this.$root.dirs.service.length);
      this.id = this.wizard?.contract?.id;

      this.updateData(this.id);
      //if (!this.id) this.afterFetchData();
    },
    async updateData() {
      this.applyData(this.wizard?.contract || {});
      this.afterFetchData();
    },
    onSelect(v) {
      //console.log("select", v);
      this.updateData(v.value);
    },
    formatData(data) {
      let res = {};
      this.model.forEach((m) => {});
    },
    afterFetchData(r) {
      this.wizardData = Object.assign({}, this.wizard.contract);
      this.calcModel();
      if (!(this.wizard?.contract?.template_data || []).find((t) => t.type == 4)) {
        const services = (this.wizard?.services?.services || []).map((s) => s.service_id);
        const appendixList = this.getOptions({ name: "type", options: "appendix_type" });
        let appendix = appendixList.find((a) => a.value == 4);
        const square = this.wizard?.object?.data?.ap_area || 1;
        let res = {
          type: 4,
          sort: 1,
          name: appendix.text,
          regdate: new Date().date,
          template_id: 22,
          config: appendix.config,
          data: this.$root.dirs.service
            .filter((s) => services.includes(s.id))
            .map((d) => {
              let ratio = d?.data?.client_ratio || 1;
              return {
                id: d.id,
                service_id: d.id,
                name: d.name,
                department: d?.department,
                days: d.data.day_business,
                work_days: Math.ceil((d.data?.day_business * square * 1.3) / 100),
                work_cost: d.price_business * square * ratio,
                description: d?.data?.description,
                square: square,
                price_square: d.price_business * ratio,
              };
            }),
        };
        this.data.template_data = [res];
      }
      this.loaded = true;
    },
    calcModel(t) {
      let config = this.config;
      let model = this.calcModelConfig(config, this.m);

      this.fillFormFromModel(model);
      this.model = model;
      if (!this.wizard.contract?.template_id) {
        this.$nextTick(() => {
          this.$refs.formContract.$refs["input_contract_type"][0].onInput(this.data.contract_type);
        });
      }
      return model;
    },

    async post(data, api, silent = false) {
      this.loading = true;
      try {
        this.wizardData = Object.assign({}, data);
        const result = await this.waitForEvent("save", this.wizardData);
        if (!result.ok) throw result;
        this.afterSave(data, status);
      } catch (error) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка при сохранении " + error?.message,
        });
        this.loading = false;
        return;
      }
    },
    async afterSave(data, status) {
      //await this.init({ id: data.id });
      this.isChanged = false;
    },
    async onUndo() {
      await this.waitForEvent("save", {});
      this.$emit("next", -1);
    },
    async onNext() {
      this.$emit("next");
    },
  },
};
</script>
